import { cn } from '@core/utils';

interface CenteredDetailTemplateProps {
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  footerClassName?: string;
  //* 한 화면에 딱 맞아야 하는 페이지에서 데스크톱 헤더 높이만큼 본문 영역을 줄여 세로 스크롤을 없앤다.
  //* GlobalLayout이 data-header-offset-page article을 감지해 wrapper min-height를 보정한다.
  headerOffsetPage?: boolean;
}

/**
 * cta footer를 옵셔널하게 추가할 수 있는 단순한 형태의 상세 페이지
 */
export const CenteredDetailTemplate = ({
  children,
  footer,
  className,
  fullWidth = false,
  footerClassName,
  headerOffsetPage = false,
}: CenteredDetailTemplateProps) => {
  return (
    <>
      <article
        data-header-offset-page={headerOffsetPage || undefined}
        className={cn(
          'mx-auto flex w-full flex-col',
          !fullWidth && 'max-w-[750px]',
          footer && 'pb-80',
          headerOffsetPage && 'flex-1',
          className,
        )}
      >
        {children}
      </article>
      {footer ? (
        <footer
          className={cn(
            'fixed inset-x-0 bottom-0 z-[1] bg-Gray-white',
            footerClassName,
          )}
        >
          <div className="mx-auto flex w-full max-w-[750px] gap-8 px-20 py-12">
            {footer}
          </div>
        </footer>
      ) : null}
    </>
  );
};
